import React, {useEffect, useState} from 'react'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {KTCard} from '../../../../../_metronic/helpers'
import {Button, Col, Container, Form, Row} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from '../../../../components/DatePicker'
import {reactSelectValue} from '../../../../utils/Helper'
import api from '../../../../utils/Api'
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom'
import moment from 'moment'
import _, {find, isEmpty} from 'lodash'
import {
  DEFAULT_VAT_TYPE,
  DiscountType,
  IncomeDocumentStateTypes,
  IncomeDocumentTypes,
} from '../../../../constants/Common'
import FormVatType from '../../../../components/form/FormVatType'
import ExpenseAccountOrderSummary from '../../../../components/app/ExpenseAccountOrderSummary'
import FormProductItems from '../../../../components/form/FormProductItems'
import AccountOrderSummary from '../../../../components/app/AccountOrderSummary'
import {IIncomeDocument} from '../../../../components/app/IncomeDocumentDetailPage'
import {updateIncomeDocument} from '../../../../api/RevenueApi'
import StepperButton from '../../../../components/app/income-document-detail/StepperButton'
import FormExpenseProductItems from '../../../../components/form/FormExpenseProductItems'
import {useAuth} from '../../../auth'

const PatientCreate = () => {
  const {can} = useAuth()
  const canApprove = can('accounting_purchase_order_approve')
  const location = useLocation()
  const isInExpensePurchaseOrderAssetPage = location.pathname.includes(
    'expense-purchase-asset-order'
  )
  const [formInternal, setFormInternal] = useState<any>({})
  const [form, setForm] = useState<any>({
    // nationalCode: 'TH',
    type: isInExpensePurchaseOrderAssetPage
      ? IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER
      : IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER,
    vatType: DEFAULT_VAT_TYPE,
    items: [] as any[],
    date: moment().toDate(),
    expiryDate: moment().add(7, 'days').toDate(),
    conditionDay: 30,
  })

  const [defaultForm, setDefaultForm] = useState<any>({
    emergencyContact: {},
    marketingInfo: {},
  })

  const defaultProductPriceInfo = {
    total: 0,
    subTotal: 0,
    discountTotal: 0,
    whTaxTotal: 0,
    vatTotal: 0,
    vatItemPriceTotal: 0,
    zeroVatItemPriceTotal: 0,
    noVatItemPriceTotal: 0,
  }

  const {id} = useParams()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redir')
  const docId = searchParams.get('docId')
  const navigate = useNavigate()
  const [hasWorkItem, setHasWorkItem] = useState(false)
  const [branches, setBranches] = useState([])
  const [patients, setPatients] = useState([])
  const [branchMode, setBranchMode] = useState('branch-main')
  const [relateDocument, setRelateDocument] = useState<any>(undefined)
  const [editableDocument, setEditableDocument] = useState<any>(undefined)
  const [firstInit, setFirstInit] = useState(true)
  const [firstInit2, setFirstInit2] = useState(true)
  const [isManualCode, setIsManualCode] = useState(false)
  const [documentState, setDocumentState] = useState('draft')
  const [currentPatient, setCurrentPatient] = useState<any>(undefined)
  const [options, setOptions] = useState({
    users: [],
    treatmentItems: [],
    labCompanies: [],
    departments: [],
  })
  const [productPriceInfo, setProductPriceInfo] = useState(defaultProductPriceInfo)

  const getBranchInOption = (branchId: number): any => {
    return find(branches, {value: branchId})
  }

  const getDepartmentInOption = (departmentId: number): any => {
    return find(options.departments, {value: departmentId})
  }

  const selectedProductDefault = {
    treatmentItemId: undefined,
    quantity: 0,
    pricePerUnit: 0,
    discount: 0,
    discountPerUnit: 0,
    discountType: DiscountType.FIXED,
    subTotal: 0,
    whTax: 0,
    whTaxPrice: 0,
    vat: 'none',
  }

  const fetchDepartment = (branchId: number) => {
    api.request(
      '/account/department',
      (r) => {
        const mapped: any = r.map((d: any) => ({...d, label: d.name, value: d.id}))

        setOptions((opt: any) => ({
          ...opt,
          departments: _.uniqBy([...options.departments, ...mapped], ({value}) => value),
        }))
      },
      {
        branchId: branchId,
      }
    )
  }

  const fetchNextCode = () => {
    if (id) return
    console.log('hasWorkItem', hasWorkItem)
    api.request(
      'account/income-document/next-code',
      (r) => {
        setForm((prevForm: any) => {
          if (isManualCode) return prevForm
          return {...prevForm, code: r || ''}
        })
      },
      {
        type: isInExpensePurchaseOrderAssetPage
          ? IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER
          : IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER,
        issueTaxInvoice: false,
        vatPrice: 0,
        date: moment(form.date).format('YYYY-MM-DD'),
        departmentId: form.departmentId || undefined,
        isWork: hasWorkItem,
      }
    )
  }

  const fetchLab = (s: string = '') => {
    api.request(
      'lab-company',
      (res) => {
        setPatients(res)

        const mapped: any = res.map((lab: any) => ({...lab, label: lab.name, value: lab.id}))
        setOptions((opt: any) => ({
          ...opt,
          labCompanies: _.uniqBy([...options.labCompanies, ...mapped], ({value}) => value),
        }))
      },
      {forDropdown: 1, roleType: 'seller', s}
    )
  }

  const fetchBranch = () => {
    api.request(
      'branch',
      (r) => {
        const branches = r.map(({id, name, code}: any) => ({
          label: name,
          value: id,
          code: code,
        }))
        setBranches(branches)

        if (id) return

        api.request('profile/get-active-branch', (r, s) => {
          setTimeout(() => {
            if (firstInit) {
              setForm((prevForm: any) => ({...prevForm, branchId: r.id}))
              setFirstInit(false)
            }
            fetchDepartment(r.id)
          }, 500)
        })
      },
      {forDropdown: true}
    )
  }

  const onSelectChange = ({value}: any, action: any, conditionDay?: number) => {
    setForm({...form, [action.name]: value, ...(conditionDay && {conditionDay: conditionDay})})
  }
  const onDateChange = (date: Date, e: any, name: string) => {
    setForm({...form, [name]: date})
  }
  const onCheckboxChange = (e: any) => {
    if (!e.target.checked) {
      setForm({...form, [e.target.name]: 0})
    }
  }

  useEffect(() => {
    if (!id && !firstInit2) {
      setTimeout(() => {
        fetchNextCode()
      }, 500)
    }

    fetchLab()
    fetchBranch()
  }, [form.date, firstInit2])

  useEffect(() => {
    if (!firstInit && !firstInit2) {
      fetchNextCode()
    }
  }, [form.items, firstInit2])

  useEffect(() => {
    if (!docId) {
      setFirstInit2(false)
      return
    }

    api.request(`account/income-document/${docId}`, (res) => {
      if (!res) return

      const isWorkItem = !!res.incomeDocumentItems?.some(
        (x: any) => x?.type === 'work' || x?.inventoryProduct?.type === 'work'
      )

      if (firstInit2) {
        setHasWorkItem(isWorkItem)
        setTimeout(() => {
          fetchNextCode()
          setFirstInit2(false)
        }, 500)
      }

      setRelateDocument(res)
    })
  }, [docId, hasWorkItem, firstInit2])

  useEffect(() => {
    if (!relateDocument) return

    const hasDepartment = !!relateDocument?.departmentId
    const relatedBranchId = relateDocument?.branchId || ''
    setBranchMode(hasDepartment ? 'branch-sub' : 'branch-main')
    if (relatedBranchId) {
      fetchDepartment(relatedBranchId)
    } else if (hasDepartment && relateDocument?.departmentId) {
      // Some PR documents keep branchId empty in sub-branch mode; resolve branch via department.
      api.request(`account/department/${relateDocument.departmentId}`, (departmentRes: any) => {
        const branchIdFromDepartment = Number(departmentRes?.branchId) || 0
        if (branchIdFromDepartment > 0) {
          fetchDepartment(branchIdFromDepartment)
        }
      })
    }

    setForm((prev: any) => ({
      ...prev,
      labCompanyId: relateDocument.labCompanyId,
      sellerId: relateDocument?.sellerId || '',
      branchId: hasDepartment ? '' : relatedBranchId,
      departmentId: relateDocument?.departmentId || '',
      saleChannel: relateDocument?.saleChannel || '',
      vatType: relateDocument.vatType,
      linkingDocumentId: relateDocument.id,
    }))
  }, [relateDocument])

  // useEffect(() => {
  //   if (!form?.branchId) return
  //   const currentBranch = getBranchInOption(form?.branchId)
  //
  //   if (!currentBranch) return
  //
  //   setTimeout(() => {
  //     fetchNextCode(currentBranch?.code)
  //   }, 500)
  // }, [form.branchId])

  useEffect(() => {
    let sumInfo = defaultProductPriceInfo

    form.items.map((item: any) => {
      if (!item.subTotal) return

      let vatTotal = item.vat === 7 ? item.subTotal * (item.vat / 100) : 0
      if (form.vatType == 'included') {
        vatTotal =
          item.vat === 7
            ? item.quantity * (item.pricePerUnit - item.discountPerUnit) - item.subTotal
            : 0
      }

      sumInfo = {
        ...sumInfo,
        total: (sumInfo.total += item.subTotal),
        subTotal: (sumInfo.subTotal += item.subTotal - item.whTaxPrice),
        discountTotal: (sumInfo.discountTotal += item.discountPerUnit * item.quantity),
        whTaxTotal: (sumInfo.whTaxTotal += item.whTaxPrice),
        zeroVatItemPriceTotal: (sumInfo.zeroVatItemPriceTotal +=
          item.vat === 0 ? item.subTotal : 0),
        noVatItemPriceTotal: (sumInfo.noVatItemPriceTotal += item.vat === 99 ? item.subTotal : 0),
        vatTotal: (sumInfo.vatTotal += vatTotal),
        vatItemPriceTotal: (sumInfo.vatItemPriceTotal += item.vat === 7 ? item.subTotal : 0),
      }
    })

    const total =
      sumInfo.vatTotal +
      sumInfo.vatItemPriceTotal +
      sumInfo.noVatItemPriceTotal +
      sumInfo.zeroVatItemPriceTotal

    sumInfo = {
      ...sumInfo,
      total: total,
      subTotal: total - sumInfo.whTaxTotal,
    }

    setProductPriceInfo(sumInfo)
  }, [form.items, form.vatType])

  useEffect(() => {
    if (!id) return

    fetchLab()
    // fetchUser()

    setTimeout(() => {
      api.request(`account/income-document/${id}`, (res) => {
        if (!res) return
        const hasDepartment = !!res?.departmentId
        setBranchMode(hasDepartment ? 'branch-sub' : 'branch-main')

        setEditableDocument(res)
        fetchDepartment(res?.branchId || '')

        setForm((prev: any) => ({
          ...prev,
          code: res.code,
          date: moment(res.date).toDate(),
          expiryDate: moment(res.expiryDate).toDate(),
          labCompanyId: res.labCompanyId,
          sellerId: res?.sellerId || '',
          branchId: hasDepartment ? '' : res?.branchId || '',
          departmentId: res?.departmentId || '',
          saleChannel: res?.saleChannel || '',
          conditionDay: res?.conditionDay || '',
          vatType: res.vatType,
          items: [],
        }))
      })
    }, 250)
  }, [id])

  const _renderSaveButton = () => {
    if (id && editableDocument) {
      return (
        <Button
          onClick={() => setDocumentState(editableDocument.state)}
          variant='info'
          type='submit'
          className={'ms-3'}
        >
          แก้ไข
        </Button>
      )
    }

    return (
      <>
        <Button type='submit' onClick={() => setDocumentState('draft')}>
          {'บันทึกร่าง'}
        </Button>
        {canApprove && (
          <Button
            onClick={() => setDocumentState('approved')}
            variant='info'
            disabled={!form?.labCompanyId}
            type='submit'
            className={'ms-3'}
          >
            {isInExpensePurchaseOrderAssetPage ? 'อนุมัติใบสั่งซื้อสินทรัพย์' : 'อนุมัติใบสั่งซื้อ'}
          </Button>
        )}
        <Button
          onClick={() => setDocumentState('await-approval')}
          variant='info'
          type='submit'
          disabled={!form?.labCompanyId}
          className={'ms-3'}
        >
          ส่งอนุมัติ
        </Button>
        <Button
          className={'ms-3'}
          onClick={() => {
            if (redirect) {
              navigate(redirect)
              return
            }
            navigate(-1)
          }}
          variant='secondary'
          type='reset'
        >
          ยกเลิก
        </Button>
      </>
    )
  }

  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <div className={'d-flex gap-3 mb-4 flex-wrap'}>
          <StepperButton title={'ใบสั่งซื้อ'} state='pending' />
          <StepperButton title={'บันทึกซื้อสินค้า'} state='disabled' />
          <StepperButton title={'ชำระเงิน'} state='disabled' />
        </div>

        <Form
          onKeyDown={(e) => {
            if (e.key !== 'Enter') return
            e.preventDefault()
          }}
          onSubmit={(e) => {
            e.preventDefault()

            const normalizedBranchId = branchMode === 'branch-sub' ? '' : form.branchId || ''
            const normalizedDepartmentId =
              branchMode === 'branch-sub' ? form.departmentId || '' : ''

            let _form = {
              ...form,
              branchId: normalizedBranchId,
              departmentId: normalizedDepartmentId,
              date: moment(form.date).format('YYYY-MM-DD'),
              expiryDate: moment(form.expiryDate).format('YYYY-MM-DD'),
              netAmount: productPriceInfo.subTotal,
              totalAmount: productPriceInfo.total,
              discountPrice: productPriceInfo.discountTotal,
              issueTaxInvoice: 0,
              items: form.items.map((item: any) => {
                const netPricePerUnit = item.pricePerUnit - item.discountPerUnit
                const subTotal = netPricePerUnit * item.quantity
                const vatPrice =
                  item.vat === 99
                    ? 0
                    : form.vatType === 'included'
                    ? parseFloat((subTotal - (subTotal * 100) / (100 + item.vat)).toFixed(2))
                    : subTotal * (item.vat / 100)

                return {
                  accountCode: item?.accountCode || '',
                  note: item?.note || '',
                  treatmentItemId: item.treatmentItemId,
                  inventoryProductId: item.inventoryProductId,
                  quantity: item.quantity,
                  pricePerUnit: item.pricePerUnit,
                  discountPerUnit: item.discountPerUnit,
                  beforeVatPrice: form.vatType === 'included' ? subTotal - vatPrice : subTotal,
                  vat: item.vat === 'none' ? 99 : item.vat,
                  vatPrice: vatPrice,
                  whTax: item.whTax,
                  whTaxPrice: parseFloat((item.subTotal * (item.whTax / 100)).toFixed(2)),
                }
              }),
            }

            const issuedDocuments =
              relateDocument?.childrenDocuments?.filter((doc: IIncomeDocument) => {
                const isPoType = isInExpensePurchaseOrderAssetPage
                  ? doc.type === IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER
                  : doc.type === IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER

                const isActiveState = !['voided', 'cancelled'].includes(
                  String(doc?.state || '').toLowerCase()
                )

                return isPoType && isActiveState
              }) || []

            _form = {
              ..._form,
              state: documentState,
              whTaxPrice: Number(
                _form.items.reduce((a: any, b: any) => a + b.whTaxPrice, 0).toFixed(2)
              ),
              vatPrice: Number(
                _form.items.reduce((a: any, b: any) => a + b.vatPrice, 0).toFixed(2)
              ),
            }

            api.request(
              id ? `account/income-document/${id}` : 'account/income-document',
              (r, s) => {
                if (!s) return

                // Update source PR document with remainTotalAmount
                if (relateDocument && _form.state === 'approved') {
                  const prItems = relateDocument.incomeDocumentItems || []

                  // Track remaining quantity per PR item (ordered consumption)
                  const prRemaining = prItems.map((item: any) => ({
                    treatmentItemId: String(item.treatmentItemId),
                    remaining: Number(item.quantity || 0),
                  }))

                  // Deduct from existing child PO items
                  for (const childDoc of issuedDocuments) {
                    for (const item of childDoc.incomeDocumentItems || []) {
                      const key = String(item.treatmentItemId)
                      let qty = Number(item.quantity || 0)
                      for (const pr of prRemaining) {
                        if (pr.treatmentItemId !== key || pr.remaining <= 0) continue
                        const deduct = Math.min(pr.remaining, qty)
                        pr.remaining -= deduct
                        qty -= deduct
                        if (qty <= 0) break
                      }
                    }
                  }

                  // Deduct from current form items
                  for (const item of _form.items) {
                    const key = String(item.treatmentItemId)
                    let qty = Number(item.quantity || 0)
                    for (const pr of prRemaining) {
                      if (pr.treatmentItemId !== key || pr.remaining <= 0) continue
                      const deduct = Math.min(pr.remaining, qty)
                      pr.remaining -= deduct
                      qty -= deduct
                      if (qty <= 0) break
                    }
                  }

                  const totalRemainingQty = prRemaining.reduce(
                    (sum: number, pr: any) => sum + (pr.remaining > 0 ? pr.remaining : 0),
                    0
                  )
                  const remainTotalAmount = totalRemainingQty
                  const isCompletely = totalRemainingQty === 0

                  updateIncomeDocument(
                    relateDocument.id,
                    {
                      remainTotalAmount,
                      state: isCompletely
                        ? IncomeDocumentStateTypes.COMPLETELY
                        : IncomeDocumentStateTypes.PARTIAL,
                    },
                    () =>
                      navigate(
                        isInExpensePurchaseOrderAssetPage
                          ? '/expense-purchase-asset-order'
                          : '/expense-purchase-order'
                      )
                  )

                  return
                }

                if (isInExpensePurchaseOrderAssetPage)
                  return navigate('/expense-purchase-asset-order')
                navigate('/expense-purchase-order')
              },
              api.form(_form, null),
              id ? 'PATCH' : 'POST',
              {showSuccess: true}
            )
          }}
        >
          <div
            className='row-vcenter cursor-pointer link fs-5'
            onClick={() => {
              navigate(-1)
            }}
          >
            <i className='bi bi-arrow-left fs-6 me-3'></i>ย้อนกลับ
          </div>
          <KTCard className='py-6 mb-6'>
            <Container>
              <Row>
                {isInExpensePurchaseOrderAssetPage ? (
                  <h1 className={'mb-0'}>
                    {id ? 'แก้ไขใบสั่งซื้อสินทรัพย์' : 'สร้างใบสั่งซื้อสินทรัพย์'}
                  </h1>
                ) : (
                  <h1 className={'mb-0'}>{id ? 'แก้ไขใบสั่งซื้อ' : 'สร้างใบสั่งซื้อ'}</h1>
                )}
                <Form.Group className='mb-5' controlId='code'>
                  <Form.Label>เลขที่เอกสาร</Form.Label>
                  <Form.Control
                    disabled={!!id}
                    name='code'
                    value={form.code}
                    onChange={(e) => {
                      setIsManualCode(true)
                      setForm({...form, code: e.target.value})
                    }}
                  />
                </Form.Group>
              </Row>
              <hr className={'mt-1'} />
              <h2 className={'mb-0 h3'}>ข้อมูลผู้ขาย</h2>
              <Row>
                <Col xs={12}>
                  <Form.Group className='mb-5' controlId='labCompanyId'>
                    <Form.Label>
                      ชื่อผู้ขาย <span className='text-danger'>*</span>
                    </Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      options={options.labCompanies}
                      name='labCompanyId'
                      placeholder='พิมพ์เพื่อค้นหาผู้ขาย'
                      onChange={(opt, action) => {
                        const value = opt.value
                        const labData = find(options.labCompanies, {value: value})

                        onSelectChange(
                          opt,
                          action,
                          (labData as any)?.creditTerm && !Number.isNaN((labData as any).creditTerm)
                            ? Number((labData as any).creditTerm)
                            : 30
                        )
                        setCurrentPatient(find(patients, {id: value}))
                      }}
                      onInputChange={(s) => {
                        if (!s) return fetchLab()

                        if (s.length > 1) {
                          fetchLab(s)
                        }
                      }}
                      noOptionsMessage={({inputValue}) => {
                        if (inputValue.length >= 2) {
                          return 'ไม่พบข้อมูล'
                        }
                        return 'ค้นหาผู้ขายโดยการพิมพ์ 2 ตัวอักษรขึ้นไป'
                      }}
                      value={reactSelectValue(options.labCompanies, form.labCompanyId)}
                    />
                  </Form.Group>
                  {!!reactSelectValue(options.labCompanies, form.labCompanyId)?.code && (
                    <div
                      style={{
                        marginTop: '-22px',
                        marginBottom: '6px',
                        marginLeft: '4px',
                        color: '#808080',
                      }}
                    >
                      รหัสผู้ขาย: {reactSelectValue(options.labCompanies, form.labCompanyId)?.code}
                    </div>
                  )}
                </Col>
              </Row>

              <Row>
                <Col>
                  <h5 className={'mb-0'}>ที่อยู่</h5>
                  <p className={!currentPatient?.address ? 'text-muted' : ''}>
                    : {currentPatient?.address || 'ไม่พบข้อมูลที่อยู่'}
                  </p>
                </Col>
                <Col>
                  <h5 className={'mb-0'}>เบอร์โทร</h5>
                  <p className={!currentPatient?.tel ? 'text-muted' : ''}>
                    : {currentPatient?.tel || 'ไม่พบข้อมูลเบอร์ติดต่อ'}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className='mb-5' controlId='date'>
                    <Form.Label>
                      วันที่ออก <span className='text-danger'>*</span>
                    </Form.Label>
                    <DatePicker
                      onChange={onDateChange}
                      name='date'
                      selected={form.date || null}
                      dateFormat='dd/MM/yyyy'
                      timeCaption='time'
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode='select'
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-5' controlId='expiryDate'>
                    <Form.Label>
                      วันที่กำหนดส่งสินค้า <span className='text-danger'>*</span>
                    </Form.Label>
                    <DatePicker
                      onChange={onDateChange}
                      name='expiryDate'
                      selected={form.expiryDate || null}
                      dateFormat='dd/MM/yyyy'
                      timeCaption='time'
                      showMonthDropdown
                      showYearDropdown
                      maxDate={moment().add(90, 'days').toDate()}
                      dropdownMode='select'
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-5' controlId='conditionDay'>
                    <Form.Label>เงื่อนไขการชำระเงิน</Form.Label>
                    <div className={'d-flex align-items-center gap-2'}>
                      <Form.Control
                        type={'number'}
                        name='conditionDay'
                        value={form.conditionDay}
                        onChange={(e) => setForm({...form, conditionDay: e.target.value})}
                      />
                      <span>{'วัน'}</span>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <hr className={'mt-1'} />
              <h2 className={'mb-0 h3'}>กลุ่มจัดประเภท</h2>
              <Row>
                <Col xs={6}>
                  <Row>
                    <Col xs={12} className={'d-flex'}>
                      <Form.Check
                        type={'radio'}
                        label={`สาขาหลัก`}
                        id={`branch-main`}
                        name={'branchMode'}
                        value={'branch-main'}
                        checked={'branch-main' === branchMode}
                        onChange={(e) => {
                          setBranchMode(e.target.value)
                          setForm((prev: any) => ({...prev, departmentId: ''}))
                        }}
                      />
                      <Form.Check
                        type={'radio'}
                        label={`สาขาย่อย`}
                        id={`branch-sub`}
                        className={'ms-3'}
                        name={'branchMode'}
                        value={'branch-sub'}
                        checked={'branch-sub' === branchMode}
                        onChange={(e) => {
                          setBranchMode(e.target.value)
                          setForm((prev: any) => ({...prev, branchId: ''}))
                        }}
                      />
                    </Col>
                    <Col>
                      {branchMode === 'branch-sub' ? (
                        <Form.Group className='mb-5'>
                          <Form.Label>
                            แผนก <span className='text-danger'>*</span>
                          </Form.Label>
                          <Select
                            classNamePrefix='react-select'
                            options={options.departments}
                            name='departmentId'
                            onChange={onSelectChange}
                            value={reactSelectValue(options.departments, form.departmentId)}
                          />
                        </Form.Group>
                      ) : (
                        <Form.Group className='mb-5' controlId={'branchId'}>
                          <Form.Label>
                            สาขา <span className='text-danger'>*</span>
                          </Form.Label>
                          <Select
                            name='branchId'
                            classNamePrefix='react-select'
                            options={branches}
                            placeholder='เลือกสาขา'
                            value={reactSelectValue(branches, form.branchId)}
                            onChange={onSelectChange}
                          />
                        </Form.Group>
                      )}
                    </Col>
                  </Row>
                </Col>
                {/*<Col>*/}
                {/*  <Form.Group className='mb-5' controlId={'taxExpense'}>*/}
                {/*    <Form.Label>*/}
                {/*      ค่าใช้จ่ายทางภาษี <span className='text-danger'>*</span>*/}
                {/*    </Form.Label>*/}
                {/*    <Select*/}
                {/*      classNamePrefix='react-select'*/}
                {/*      options={TAX_EXPENSE_OPTIONS}*/}
                {/*      name='taxExpense'*/}
                {/*      onChange={onSelectChange}*/}
                {/*      value={reactSelectValue(TAX_EXPENSE_OPTIONS, form.taxExpense)}*/}
                {/*    />*/}
                {/*  </Form.Group>*/}
                {/*</Col>*/}
              </Row>
              <hr className={'mt-1'} />
              <h2 className={'mb-0 h3'}>ข้อมูลราคาและภาษี</h2>
              <Col>
                <FormVatType
                  disabledIssueTax
                  currentDocumentForm={form}
                  previousVatType={relateDocument?.vatType}
                  onChange={(data) => {
                    setForm({
                      ...form,
                      ...data,
                    })
                  }}
                />
              </Col>
              <hr className={''} />
              <div className={'d-flex align-items-end'}>
                <h2 className={'mb-0 h3 me-2'}>รายการ</h2>
                <span>(สินค้าและบริการ)</span>
              </div>
              <FormExpenseProductItems
                documentType={IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER}
                branchId={form?.branchId || getDepartmentInOption(form?.departmentId)?.branchId}
                departmentId={form?.departmentId}
                vatType={form.vatType}
                previousDocument={relateDocument}
                previousItems={
                  !isEmpty(editableDocument)
                    ? editableDocument?.incomeDocumentItems
                    : relateDocument?.incomeDocumentItems
                }
                onChange={(data: any[], opts) => {
                  setForm({...form, items: data})
                  setHasWorkItem(opts.hasWorkItem)
                }}
              />
              <hr className={'mt-5'} />
              <h2 className={'mb-3 h3'}>สรุปข้อมูล</h2>
              <ExpenseAccountOrderSummary productPriceInfo={productPriceInfo} />
              <hr className={'mt-1'} />
              <h2 className={'mb-0 h3'}>หมายเหตุสำหรับผู้ขาย</h2>
              <Form.Group className='mb-5' controlId='note'>
                <Form.Label>หมายเหตุ</Form.Label>
                <Form.Control
                  as='textarea'
                  rows={2}
                  name='note'
                  value={form.note}
                  onChange={(e) => setForm({...form, note: e.target.value})}
                />
              </Form.Group>
            </Container>
          </KTCard>

          <div className='row-center'>{_renderSaveButton()}</div>
        </Form>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export default PatientCreate
